import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx } from "vue"

import { PropType } from "vue";

import { IIdentifier, IService } from "@/types/identifier";

import UiGroup from "@/plugins/ui/components/group/UiGroup.vue";
import UiHeader from "@/plugins/ui/components/header/UiHeader.vue";

import IdentifierCard from "./IdentifierCard.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'IdentifiersList',
  props: {
  identifiers: {
    type: Array as PropType<Array<IIdentifier & { services: IService[] }>>,
    default: () => [],
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UiGroup, null, {
    header: _withCtx(() => [
      _createVNode(UiHeader, { title: "Список идентификаторов" })
    ]),
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.identifiers, (identifier) => {
        return (_openBlock(), _createBlock(IdentifierCard, {
          key: identifier.id,
          identifier: identifier
        }, null, 8, ["identifier"]))
      }), 128))
    ]),
    _: 1
  }))
}
}

})